import moment from 'moment';


export function formatUnixDate(recDate: number | string | Date) {
  const a = new Date(recDate);
  const year = a.getFullYear();
  const month = a.getMonth() + 1;
  const date = a.getDate();

  return `${year}-${month}-${date}`;
}

export function formatMessageDate(timestamp: moment.MomentInput) {
  return moment(timestamp).format('h:mm A');
}
